import DealsPage from './views/DealsPage.vue';

export default [
  {
    path: '/deals',
    name: 'deals',
    component: DealsPage,
    meta: {
      title: 'Deals & Promos',
      headerVisible: true,
      headerColor: 'default',
      requiresAuth: true
    }
  },
  {
    path: '/deals/:id',
    name: 'deal-detail',
    component: () => import('./views/DealDetailPage.vue'),
    meta: {
      title: 'Détails du Deal',
      headerVisible: true,
      headerColor: 'default',
      requiresAuth: false
    }
  }
];
